export enum Product {
  PDL = 'PDL',
  ILS = 'ILS',
}
